import { Component, AfterViewInit, ElementRef, NgZone, ViewChild, viewChild } from '@angular/core'
import { GetExcel } from '../../get.excel'
import { FileUploader } from 'ng2-file-upload'
import { PortalGlobals } from '../../../../app/portalglobals'
import { GoodStandingModel } from '../../../common/models/good-standing-model'
import { TrainingCertificatesGateway } from '../../../training/gateways/training-certificates-gateway'
import { CurrentUser } from '../../../common/models/current-user'

import { Router } from '@angular/router'
import { Title } from '@angular/platform-browser'

const URL = '../api/UploadGroupExcel'

@Component({
    templateUrl: './group-enrollment.component.html',
    styleUrls: ['group-enrollment.component.scss']
})
export class GroupEnrollmentComponent implements AfterViewInit {
    public uploader: FileUploader = new FileUploader({ url: URL, itemAlias: 'gourpExcel' })

    Messages: any
    ErrorMessage: string | null
    successOrErrorMessage: string
    validateeContract = false
    errorlist: any[]
    errorlists: any[]
    isFormValid: boolean
    isFormServiceValidationValid: boolean
    response: string
    errors: any[]
    hideStepTwo: boolean
    showErrors: boolean
    SuccessMessage: string | null
    FileName: string | null
    confirmationFile: string
    @ViewChild('fileInput') fileInput: any
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    @ViewChild('focusableEleSuccess') focusableEleSuccess: ElementRef
    curPlanYear = 'curPlanYear'
    public loading: boolean = false
    IsEgwpUserTraining: boolean = true
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    planyear: number
    public currentUser: CurrentUser = {} as CurrentUser
    IsSSI: boolean
    visibleFrom2025: boolean
    @ViewChild('singleEnrollmentLink') singleEnrollmentLink!: ElementRef;
    baseTitle: string

    constructor(
        private getExcel: GetExcel,
        private el: ElementRef,
        private ngZone: NgZone,
        private portalGlobal: PortalGlobals,
        private trainingCertificatesGateway: TrainingCertificatesGateway,
        private router: Router,
        private routers: Router,
        private titleService: Title
    ) {
        this.getExcel = getExcel
        let self = this
        this.uploader.onErrorItem = this.ngZone.run(
            () =>
                function (item, response, status, headers) {
                    let error: any = JSON.parse(response)
                    self.errors = error.errors
                    //self.showErrors = true;
                    console.log(self.errors.length)
                }
        )

        let currentYear = localStorage.getItem('curPlanYear')
        this.uploader = new FileUploader({
            url: URL,
            itemAlias: 'gourpExcel',
            additionalParameter: { planYear: this.portalGlobal.selectedPlanYear ? this.portalGlobal.selectedPlanYear : currentYear }
        })

        this.uploader.response.subscribe(
            (res) => ((this.response = res), console.log(this.response), (this.loading = false), this.handleResponse(this.response))
        )

        this.uploader.onAfterAddingFile = (fileItem) => {
            fileItem.withCredentials = false
            console.log(fileItem) // fileItem is the file object
        }

        this.uploader.onCompleteAll = () => {
            this.fileInput.nativeElement.value = ''
        }
    }

    ngAfterViewInit() {
        this.singleEnrollmentLink.nativeElement.focus();
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')

        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle(this.baseTitle + ' - Group Enrollment')

        this.currentUser = JSON.parse(User!)
        if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameSSI) this.IsSSI = true
        else this.IsSSI = false

        this.visibleFrom2025 = this.portalGlobal.selectedPlanYear > this.portalGlobal.Planyear2024

        if (this.currentUser.roleCode === 'Data Entry Group Specialist') {
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams') || '')
            if (sessionStorage.getItem('GoodStandingParams') !== null) {
                if (!this.goodStandingValues.CurriculumStatus) {
                    this.planyear = this.portalGlobal.selectedPlanYear
                    this.IsEgwpUserTraining = false
                }
            }
        } else {
            this.IsEgwpUserTraining = true
        }
    }

    NavigateURL() {
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameSSI)
            this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1/1'])
        else this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
    }

    GetTrainingURL() {
        /*
        this.trainingCertificatesGateway.LogintoCourseGuide(this.currentUser.userProfileName,
            this.portalGlobal.selectedPlanYear).subscribe
            ((data) => {
                window.open(data, '_blank')
            })
        */
        const insCo = this.portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigate(['/' + insCo + '/training/trainingDetail'])
    }
    getFile() {
        document.getElementById('upfile')?.click()
    }
    sub(obj) {
        this.FileName = null
        var file = obj.fileInput.nativeElement.value
        var fName = file.split('\\')
        this.FileName = fName[fName.length - 1]
        event?.preventDefault()
    }
    handleResponse(response: string) {
        localStorage.setItem('curPlanYear', this.portalGlobal.selectedPlanYear.toString())
        this.hideStepTwo = false
        this.showErrors = false
        this.SuccessMessage = null
        this.ErrorMessage = null
        this.Messages = ''
        if (response != null) {
            response = response.substring(2).slice(0, -2)
            this.Messages = response.split('",')
        }

        if (this.response.indexOf('enrollments processed successfully') >= 0) {
            for (let i = 0; i < this.Messages.length - 1; i++) {
                this.hideStepTwo = true
                if (this.SuccessMessage == null) {
                    this.SuccessMessage = this.Messages[i]
                } else {
                    this.SuccessMessage = this.SuccessMessage.concat(this.Messages[i].slice(1))
                }
                this.confirmationFile = this.Messages[this.Messages.length - 1].slice(1)
                this.focusableEleSuccess.nativeElement.focus()
            }
        } else {
            for (let i = 0; i < this.Messages.length; i++) {
                this.showErrors = true
                if (this.ErrorMessage == null) {
                    this.ErrorMessage = this.Messages[i]
                } else {
                    this.ErrorMessage = this.ErrorMessage.concat(this.Messages[i].slice(1))
                }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
        if (response.indexOf('enrollments processed successfully') >= 0) {
        }
    }

    refresh(): void {
        window.location.reload()
    }

    saveDetails() {
        // to test
        // this.confirmationFile = "confirmation-numbers-2018-02-28_23-13-07-372.txt";
        this.getExcel.getContirmationText(this.confirmationFile).subscribe((data) => this.downloadFile(data)), //console.log(data),
            (error) => console.log('Error downloading the file.'),
            () => console.info('OK')
    }

    downloadFile(data: BlobPart) {
        var blob = new Blob([data], { type: 'text/plain' }),
            e = document.createEvent('MouseEvents'),
            a = document.createElement('a')
        // FOR IE:

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            ;(window.navigator as any).msSaveOrOpenBlob(blob, 'SilverScript-Enrollment-Confirmations.txt')
        } else {
            var e = document.createEvent('MouseEvents'),
                a = document.createElement('a')

            a.download = 'SilverScript-Enrollment-Confirmations'
            a.href = window.URL.createObjectURL(blob)
            a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':')
            e.initEvent('click', true, true)
            a.dispatchEvent(e)
        }
    }

    downlaodExcelTemplate() {
        this.getExcel.getSpreadsheet(this.portalGlobal.selectedPlanYear.toString()).subscribe((data) => {
            if ((window.navigator as any).msSaveOrOpenBlob) {
                ;(window.navigator as any).msSaveBlob(data, 'SilverScript_Template_20230930.xlsx')
            } else {
                if (this.portalGlobal.selectedPlanYear.toString() == '2024') {
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
                    link.download = 'SilverScript_Template_20230930.xlsx'
                    document.body.appendChild(link)
                    link.click()
                    // Revoking is tricky
                    // https://code.google.com/p/chromium/issues/detail?id=375297#c7
                    window.setTimeout(function () {
                        window.URL.revokeObjectURL(link.href)
                        document.body.removeChild(link)
                    }, 100)
                } else if (this.visibleFrom2025) {
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
                    link.download = 'SilverScript_Template_20251001.xlsx'
                    document.body.appendChild(link)
                    link.click()
                    // Revoking is tricky
                    // https://code.google.com/p/chromium/issues/detail?id=375297#c7
                    window.setTimeout(function () {
                        window.URL.revokeObjectURL(link.href)
                        document.body.removeChild(link)
                    }, 100)
                }
            }
        })
    }
    uploadButtonClick() {
        this.loading = true
        this.uploader.uploadAll()
    }
}
